export enum ATTRIBUTES {
    LESSON_SOURCE = 'lesson_source',
}

export type AttributesType = Record<ATTRIBUTES, string | Array<string>>;
